<template>
	<div class="copy-button-container" :class="{'inline': inline}">
		<div
			class="copy-button"
			@click="onCopyEmailClick"
			v-tooltip.top="{ value: inline ? hintText : ''}"
		>
			<span>{{ translate( teamEmailTranslationKey, { teamCode } ) }}</span>
			<font-awesome-icon v-if="!inline" :icon="[ `far`, `copy` ]" />
		</div>
		<p v-if="!inline" ref="emailHint" class="email-hint">{{ hintText }}</p>
	</div>
</template>
<script>
import useClipboard from "vue-clipboard3";
import TranslateMixin from "../../mixins/TranslateMixin";

export default {
	name: "CopyableTeamEmail",
	mixins: [ TranslateMixin, ],
	teamingPackage: "common-ui",
	props: {
		teamCode: {
			type: String,
			required: true,
		},
		inline: {
			type: Boolean,
			default: false,
		},
	},
	data( ) {
		return {
			copied: false,
		};
	},
	computed: {
		teamEmailTranslationKey() {
			const { config, } = this.$foundation();
			const stage = config.environment;
			if (['development', 'test'].includes(stage)) {
				return `teamEmail.${stage}`;
			}
			return 'teamEmail.default';
		},
		hintText() {
			return this.copied ? this.translate( "emailHintCopied" ) : this.translate("emailHint");
		},
	},
	methods: {
		async onCopyEmailClick( e ) {
			const { toClipboard, } = useClipboard();
			await toClipboard( this.translate( this.teamEmailTranslationKey, { teamCode: this.teamCode } ) );

			// change the help text to "copied" for a few seconds
			this.copied = true;
			setTimeout( ( ) => {
				this.copied = false;
			}, 3000 );

		},
	},

};
</script>

<style lang="scss" scoped>
	.copy-button-container {
		.copy-button {
			cursor: pointer;
			span {
				font-size: 16px;
				font-family: "Noto Sans Mono";
				font-style: normal;
				font-weight: 600;
				line-height: 24px;
			}
		}

		&.inline {
			display: inline;
			.copy-button {
				display: inline;
				text-decoration: underline;
				text-decoration-style: dashed;
				text-underline-offset: 3px;
			}
		}
		&:not(.inline) {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 4px;

			.copy-button {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 8px;
				padding:  6px 12px;
				background-color: $o-surface-sunken;
				color: $o-color-text-primary;
				border-radius: 6px;
				border: 1px dashed $o-color-border-separator;
			}
			.email-hint {
				font-size: 12px;
				font-weight: 400;
				color: $o-color-text-secondary;
			}
		}
	}
</style>
